module.exports = __webpack_public_path__ + "static/media/activity12.568c86da.JPG";